import { FC } from 'react';

import { LAST_ACTION_TEXTS } from '@/consts/actions';

import { useOpenBrowser } from '@/hooks/useOpenBrowser';

import { formatDate } from '@/helpers/formatDate';

import { EyeIcon } from '@heroicons/react/24/outline';

interface IDateCellLastAction {
  pdfUrl?: string;
  action: number;
  date: string;
}

const DateCellLastAction: FC<IDateCellLastAction> = ({
  pdfUrl,
  action,
  date,
}) => {
  const handleOpenPdf = (link: string) => {
    if (!link) return;
    if (window.electron) {
      window.electron.send('open-pdf', link);
    } else {
      window.open(link, '_blank');
    }
  };

  const actionText = LAST_ACTION_TEXTS[action] || 'None';

  return (
    <div className="flex items-center gap-3">
      {pdfUrl ? (
        <div
          className="cursor-pointer w-7 h-7 flex items-center justify-center rounded-full bg-[#BDE0F5] text-[#1F2B40] transition-colors duration-200 hover:bg-[#1F2B40] hover:text-[#BDE0F5]"
          onClick={() => handleOpenPdf(pdfUrl)}>
          <EyeIcon className="w-5 h-5" />
        </div>
      ) : null}
      <span>
        {formatDate(date)}
        <br />
        {actionText}
      </span>
    </div>
  );
};

export default DateCellLastAction;
